__turbopack_context__.v({
  "content": "_20002G_content",
  "logo": "_20002G_logo",
  "logoLink": "_20002G_logoLink",
  "wrapper": "_20002G_wrapper",
});
